import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import useTemplateScripts from '../hooks/useTemplateScripts'
import { useCart } from '../Context/CartContext'
import SiteHeader from './SiteHeader'
import SiteFooter from './SiteFooter'
import CartDrawer from './CartDrawer'
import { SITE_LINKS } from '../constants/siteLinks'

function About() {
    useTemplateScripts()
    const { cartItems } = useCart()
    const [showCart, setShowCart] = useState(false)

    return (
        <div>
            <button
                type="button"
                className="scroll-top scroll-to-target"
                data-target="html"
                aria-label="Back to top"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
                <i className="fa-solid fa-angle-double-up"></i>
            </button>

            <SiteHeader cartCount={cartItems.length} onCartClick={() => setShowCart(true)} />

            <main>
                <div className="tv-about-area z-index-1 p-relative pt-130 pb-130 white-bg">
                    <div className="container">
                        <div className="row align-items-end">
                            <div className="col-xl-5 col-lg-5 scroll-animate fade-left">
                                <div className="tv-section-title-box">
                                    <span className="tv-section-subtitle tv-spltv-text tv-spltv-in-right">About Fabritech</span>
                                    <h4 className="tv-section-title pb-20 tv-spltv-text tv-spltv-in-right">Innovating Tomorrow's Technology Today</h4>
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-7 text-end scroll-animate fade-right">
                                <div className="tv-fade-anim button" data-fade-from="top" data-ease="bounce" data-delay=".5">
                                    <Link className="tv-btn-secondary" to={SITE_LINKS.contact}>
                                        <span className="btn-wrap">
                                            <span className="btn-text1">Know More</span>
                                            <span className="btn-text2">Know More</span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="tv-about-section mt-60">
                            <div className="row align-items-center">
                                <div className="col-xl-4 col-lg-6 col-md-6 scroll-animate fade-up scroll-animate-delay-1">
                                    <div className="tv-about-left">
                                        <div className="single-icon-box">
                                            <span><img src="assets/img/icon/about-icon-1.png" alt="" /></span>
                                            <div className="icon-box-content">
                                                <h3>Our Mission</h3>
                                                <p>To deliver cutting-edge technology solutions that empower businesses to connect, secure, and innovate in an increasingly digital world.</p>
                                            </div>
                                        </div>
                                        <div className="single-icon-box">
                                            <span><img src="assets/img/icon/about-icon-2.png" alt="" /></span>
                                            <div className="icon-box-content">
                                                <h3>Our Vision</h3>
                                                <p>To be the leading technology partner trusted by businesses worldwide for transformative digital solutions and unparalleled support.</p>
                                            </div>
                                        </div>
                                        <div className="single-icon-box">
                                            <span><img src="assets/img/icon/about-icon-3.png" alt="" /></span>
                                            <div className="icon-box-content">
                                                <h3>Our Values</h3>
                                                <p>Excellence, Innovation, Integrity, and Client Success drive everything we do at Fabritech.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-6 col-md-6 scroll-animate scale-up scroll-animate-delay-2">
                                    <div className="tv-about-middle">
                                        <img src="assets/img/about/about-1-1.png" alt="" />
                                        <p>Fabritech is a forward-thinking technology company specializing in Starlink & Networking, Digital Security, and Web & Software Development. We combine expertise, innovation, and dedication to deliver solutions that transform businesses and create lasting impact.</p>
                                    </div>
                                </div>
                                <div className="col-xl-4 d-xxl-block d-xl-block d-none col-md-6 col-sm-6 scroll-animate fade-right scroll-animate-delay-3">
                                    <div className="tv-about-right">
                                        <img src="assets/img/about/about-1-2.png" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <CartDrawer open={showCart} onClose={() => setShowCart(false)} />
            <SiteFooter />
        </div>
    )
}

export default About
